module.exports = __webpack_public_path__ + "media/images/common/logo-white-9a3844fb719b2af6c2833ad5921bd6c0.png";